class Vehicle {
  constructor(code, imei, numberPlate, ecgCode, stationId, vehicleTypeId) {
    this.code = code;
    this.imei = imei;
    this.numberPlate = numberPlate;
    this.ecgCode = ecgCode;
    this.stationId = stationId;
    this.vehicleTypeId = vehicleTypeId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      vehicleId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      searchModal: false,
      isSearch: false,
      modalIcon: '',
      provinceTitle: '',
      vehicleManagmentInformationTableHeaders: [
        { text: 'کد شبرنگ', value: 'code', align: 'center' },
        { text: 'IMEI', value: 'imei', align: 'center' },
        { text: 'پلاک', value: 'platNumber', align: 'center' },
        { text: 'کد دستگاه ECG', value: 'ecg', align: 'center' },
        { text: 'نوع وسیله نقلیه', value: 'type', align: 'center' },
        { text: 'پایگاه', value: 'station', align: 'center' },
        { text: 'وضعیت', value: 'status', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],
      pEnd: '',
      pMiddle: '',
      pText: '',
      pStart: '',
      statusSearchListItems: [
        { text: 'هیچکدام', id: 1 },
        { text: 'عملیاتی', id: 2 },
        { text: 'غیر عملیاتی', id: 3 },
      ],
      searchCode: '',
      searchIMeI: '',
      searchCityId: null,
      searchZoneId: null,
      searchStationId: null,
      searchVehicleTypeId: null,
      searchIsBroken: 1,
      vehiclephoneNumbers: [],
      qr: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن وسیله نقلیه';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش وسیله نقلیه';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getVehicleFunction(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.vehicle = new Vehicle('', '', '', '', null, null);
      this.pStart = '';
      this.pEnd = '';
      this.pText = '';
      this.pMiddle = '';
      this.showAddEditModal = false;
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addVehicleFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش وسیله نقلیه';
        this.$refs.confirm.text = 'از ویرایش وسیله نقلیه اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف وسیله نقلیه';
        this.$refs.confirm.text = 'از حذف وسیله نقلیه اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addVehicleFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editVehicleFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteVehicleFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.vehicleId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    //search
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfVehiclesWithPagination();
    },
    removeFilters: function () {
      this.searchCode = '';
      this.searchIMeI = '';
      this.searchCityId = null;
      this.searchZoneId = null;
      this.searchStationId = null;
      this.searchVehicleTypeId = null;
      this.searchIsBroken = 1;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfVehiclesWithPagination();
    },
    cancelSearch: function () {
      this.searchCode = '';
      this.searchIMeI = '';
      this.searchCityId = null;
      this.searchZoneId = null;
      this.searchStationId = null;
      this.searchVehicleTypeId = null;
      this.searchIsBroken = 1;
      this.searchModal = false;
    },
    showQRCode: function (qr, code) {
      let id = qr + '$$__$$' + code;
      const routeData = this.$router.resolve({
        name: 'vehicleQRCode',
        query: { data: id },
      });
      window.open(routeData.href, '_blank');
    },
    searchCityChange: function () {
      this.searchZoneId = null;
      if (this.searchCityId) {
        this.getListOfZonesForOther(this.searchCityId);
      }
    },
  },
};
